import { useTranslation } from 'react-i18next';

import { PURCHASE_ACTIONS } from 'assets/constants/purchaseActions';
import RedButton from 'components/buttons/RedButton';
import { orderService } from 'services/order/orderService';

import { TrackedItemComponentsProps } from './trackedItemUtils';

export const MeetUpButtons = ({ order, invalidRequest, onClick, onContactPress }: TrackedItemComponentsProps) => {
  const { t } = useTranslation('myProfile');
  const status = order?.status;
  const orderId = order?.id;
  const refundRequested = order?.refundRequested;

  const canMeetUp = () => {
    return status && !refundRequested && PURCHASE_ACTIONS[status].isMeetUpPossible;
  };

  const meetUp = () => {
    onClick?.();
    onContactPress?.();
  };

  const confirmPickUp = () => {
    orderService
      .markAsPickedUp(orderId!!)
      .then(() => {
        window.location.reload();
      })
      .catch(invalidRequest);
  };

  if (!canMeetUp()) return null;
  return (
    <>
      <RedButton data-testid={'meet-up-btn'} onClick={() => meetUp()}>
        {t('tracked-item.meet-up')}
      </RedButton>
      <RedButton data-testid={'confirm-pick-up-btn'} onClick={() => confirmPickUp()}>
        {t('tracked-item.confirm-pickup')}
      </RedButton>
    </>
  );
};
